import moment from "moment"

export const cargoServiceTypes = [
  { name: 'Single Default Service', id: 0 },
  { name: 'Multiple Cargo Service', id: 1 },
]

export const serviceTypeHead = [
  { headerName: 'Service Type ID', field: 'serviceTypeId', headerSx: { minWidth: '100px', textAlign: 'left' } },
  { headerName: 'Service Type', field: 'serviceType', headerSx: { minWidth: '200px' } },
  { headerName: 'Status', field: 'status', headerSx: { minWidth: '100px', textAlign: 'center' } },
  { headerName: 'Action', field: 'action', headerSx: { minWidth: '100px' } },
  { headerName: 'Modified By', field: 'modifiedBy', headerSx: { minWidth: '150px' } },
  { headerName: 'Modified Time & Date', field: 'modifiedTime', headerSx: { minWidth: '200px' } },
]

export const kgkmTableHead = [
  { headerName: 'S/N', field: 'srNo', headerSx: { textAlign: 'right' }, showfilter: false },
  { headerName: 'Service Type ID', field: 'ServiceTypeID', headerSx: {}, showfilter: true },
  { headerName: 'Service Type', field: 'ServiceType', headerSx: {}, showfilter: true },
  { headerName: 'Consignment ID', field: 'ConsignmentID', headerSx: {}, showfilter: true },
  { headerName: 'Consignment Type', field: 'SubType', headerSx: {}, showfilter: true },
  { headerName: 'From KG', field: 'FromKg', headerSx: { textAlign: 'right' }, showfilter: true },
  { headerName: 'To KG', field: 'ToKg', headerSx: { textAlign: 'right' }, showfilter: true },
  { headerName: 'From KMS', field: 'FromKm', headerSx: { textAlign: 'right' }, showfilter: true },
  { headerName: 'To KMS', field: 'ToKm', headerSx: { textAlign: 'right' }, showfilter: true },
  { headerName: 'Rate', field: 'rateVal', headerSx: { textAlign: 'right' }, showfilter: true },
  { headerName: 'Doc. Charge', field: 'docChrgeVal', headerSx: { textAlign: 'right' }, showfilter: true },
  { headerName: 'Action', field: 'action', headerSx: { minWidth: '80px' }, showfilter: false },
  { headerName: 'Modified By', field: 'UserName', headerSx: { minWidth: '130px' }, showfilter: true },
  { headerName: 'Mod. Time & Date', field: 'EntryDateTime', headerSx: { minWidth: '160px' }, showfilter: true },
]

export const kgkmTableHeadPdf = [
  { headerName: 'S/N', field: 'srNo', headerSx: { textAlign: 'right' }, showfilter: false },
  { headerName: 'Service Type ID', field: 'ServiceTypeID', headerSx: {}, showfilter: true },
  { headerName: 'Service Type', field: 'ServiceType', headerSx: {}, showfilter: true },
  { headerName: 'Consignment ID', field: 'ConsignmentID', headerSx: {}, showfilter: true },
  { headerName: 'Consignment Type', field: 'SubType', headerSx: {}, showfilter: true },
  { headerName: 'From KG', field: 'FromKg', headerSx: { textAlign: 'right' }, showfilter: true },
  { headerName: 'To KG', field: 'ToKg', headerSx: { textAlign: 'right' }, showfilter: true },
  { headerName: 'From KMS', field: 'FromKm', headerSx: { textAlign: 'right' }, showfilter: true },
  { headerName: 'To KMS', field: 'ToKm', headerSx: { textAlign: 'right' }, showfilter: true },
  { headerName: 'Rate', field: 'rateVal', headerSx: { textAlign: 'right' }, showfilter: true },
  { headerName: 'Doc. Charge', field: 'docChrgeVal', headerSx: { textAlign: 'right' }, showfilter: true },
  { headerName: 'Modified By', field: 'UserName', headerSx: { minWidth: '130px' }, showfilter: true },
  { headerName: 'Mod. Time & Date', field: 'EntryDateTime', headerSx: { minWidth: '160px' }, showfilter: true },
]


export const rateMatrixFileUploadHeader = [
  { headerName: 'S/N', field: 'srNo', headerSx: { minWidth: '20px', textAlign: 'right' } },
  { headerName: 'Service Type ID', field: 'chargeTypeId', headerSx: { minWidth: '90px', textAlign: 'right' } },
  { headerName: 'Consignment Type ID', field: 'consignmentTypeId', headerSx: { minWidth: '100px', textAlign: 'right' } },
  { headerName: 'From KG', field: 'fromKg', headerSx: { minWidth: '84px', textAlign: 'right' } },
  { headerName: 'To KG', field: 'toKg', headerSx: { minWidth: '106px', textAlign: 'right' } },
  { headerName: 'From KM', field: 'fromKm', headerSx: { minWidth: '84px', textAlign: 'right' } },
  { headerName: 'To KM', field: 'toKm', headerSx: { minWidth: '106px', textAlign: 'right' } },
  { headerName: 'Rate', field: 'rate', headerSx: { minWidth: '84px', textAlign: 'right' } },
  { headerName: 'Doc. Charge', field: 'docCharge', headerSx: { minWidth: '84px', textAlign: 'right' } },
]

export const rateMatrixHistoryHeader = [
  { headerName: 'S/N', field: 'SN', headerSx: { textAlign: 'right' } },
  { headerName: 'Service Type ID', field: 'ServiceTypeID', headerSx: { textAlign: 'right' } },
  { headerName: 'Service Type', field: 'ServiceType', headerSx: { textAlign: 'right' } },
  { headerName: 'Consignment ID', field: 'ConsignmentID', headerSx: { textAlign: 'right' } },
  { headerName: 'Consignment Type', field: 'SubType', headerSx: { textAlign: 'right' } },
  { headerName: 'From KG', field: 'FromKg', headerSx: { textAlign: 'right' } },
  { headerName: 'To KG', field: 'ToKg', headerSx: { textAlign: 'right' } },
  { headerName: 'From KMS', field: 'FromKm', headerSx: { textAlign: 'right' } },
  { headerName: 'To KMS', field: 'ToKm', headerSx: { textAlign: 'right' } },
  { headerName: 'Old Rate', field: 'OldRate', headerSx: { textAlign: 'right' } },
  { headerName: 'New Rate', field: 'NewRate', headerSx: { textAlign: 'right' } },
  { headerName: 'Old Doc. Chrg.', field: 'OldDocumentCharge', headerSx: { textAlign: 'right' } },
  { headerName: 'New Doc. Chrg.', field: 'NewDocumentCharge', headerSx: { textAlign: 'right' } },
  { headerName: 'Modified By User', field: 'ModifiedUserName', headerSx: { textAlign: 'right' } },
  { headerName: 'Mod. Time & Date', field: 'EntryDateTime', headerSx: { textAlign: 'right' } },
]
export const rateMatrixHistoryFlterHeader = [
  { headerName: 'Cargo Service Type', field: 'cargoType', headerSx: { textAlign: 'right' } },
  { headerName: 'Multi Cargo Service Type', field: 'multiCargoType', headerSx: { textAlign: 'right' } },
  { headerName: 'Consignment Type', field: 'consType', headerSx: { textAlign: 'right' } },
]
export const rateMatrixDeleteHeader = [
  { headerName: 'S/N', field: 'SN', headerSx: { textAlign: 'right' } },
  { headerName: 'Service Type ID', field: 'ServiceTypeID', headerSx: { textAlign: 'right' } },
  { headerName: 'Service Type', field: 'ServiceType', headerSx: { textAlign: 'right' } },
  { headerName: 'Consignment ID', field: 'ConsignmentID', headerSx: { textAlign: 'right' } },
  { headerName: 'Consignment Type', field: 'SubType', headerSx: { textAlign: 'right' } },
  { headerName: 'From KG', field: 'FromKg', headerSx: { textAlign: 'right' } },
  { headerName: 'To KG', field: 'ToKg', headerSx: { textAlign: 'right' } },
  { headerName: 'From KMS', field: 'FromKm', headerSx: { textAlign: 'right' } },
  { headerName: 'To KMS', field: 'ToKm', headerSx: { textAlign: 'right' } },
  { headerName: 'Old Rate', field: 'OldRate', headerSx: { textAlign: 'right' } },
  { headerName: 'New Rate', field: 'NewRate', headerSx: { textAlign: 'right' } },
  { headerName: 'Old Doc. Chrg.', field: 'OldDocumentCharge', headerSx: { textAlign: 'right' } },
  { headerName: 'New Doc. Chrg.', field: 'NewDocumentCharge', headerSx: { textAlign: 'right' } },
  { headerName: 'Modified By User', field: 'ModifiedUserName', headerSx: { textAlign: 'right' } },
  { headerName: 'Mod. Time & Date', field: 'EntryDateTime', headerSx: { textAlign: 'right' } },
]
export const standardRatehistoryHeader = [
  { headerName: 'S/N', field: 'SN', headerSx: { textAlign: 'right' } },
  { headerName: 'Source City ID', field: 'sourceCityId', headerSx: { textAlign: 'right' } },
  { headerName: 'Source City', field: 'sourceCity', headerSx: { textAlign: 'right' } },
  { headerName: 'Dest. City ID', field: 'destCityId', headerSx: { textAlign: 'right' } },
  { headerName: 'Dest. City', field: 'destCity', headerSx: { textAlign: 'right' } },
  { headerName: 'Distance in KMS', field: 'distanceInKms', headerSx: { textAlign: 'right' } },
  { headerName: 'By Bus', field: 'byBus', headerSx: { textAlign: 'right' } },
  { headerName: 'By Cargo', field: 'byCargo', headerSx: { textAlign: 'right' } },
  { headerName: 'By Express Cargo', field: 'byExpressCargo', headerSx: { textAlign: 'right' } },
  { headerName: 'By Partner Cargo', field: 'byPartnerCargo', headerSx: { textAlign: 'right' } },
  { headerName: 'Modified By', field: 'modifiedBy', headerSx: { textAlign: 'right' } },
  { headerName: 'Modified Time & Date', field: 'modifiedTimeAndDate', headerSx: { textAlign: 'right' } },
];

export const chargeTypeList = ['Per KG', 'Per KG-KM', 'Per KG', 'Per KG-KM', 'Per KG', 'Per KG-KM']
export const standardRateHead = [
  { headerName: 'Service\nID', dropDown: '', field: 'ServiceTypeID', headerSx: { minWidth: "100px" } },
  { headerName: 'Service\nType', dropDown: '', field: 'ServiceType', headerSx: { minWidth: "100px", borderRight: '1px solid rgba(224, 224, 224, 1)' } },
  { headerName: 'Freight\nCharges', dropDown: 'FreightBillUnit', headerSx: { minWidth: "120px" }, field: 'Freight' },
  { headerName: 'Collection\nCartage', dropDown: 'CollCartageBillUnit', headerSx: { minWidth: "120px" }, field: 'CollCartage' },
  { headerName: 'Del. Cartage\nOn Booking', dropDown: 'CartageDelBillUnit', headerSx: { minWidth: "120px" }, field: 'CartageDel' },
  { headerName: 'Document\nCharges', dropDown: 'DocChgBillUnit', headerSx: { minWidth: "120px" }, field: 'DocChg' },
  { headerName: 'Hamali\nCharge', dropDown: 'HamaliChgBillUnit', headerSx: { minWidth: "120px" }, field: 'HamaliChg' },
  { headerName: 'Opr. Hamali\nCharge', dropDown: 'OptHamChgBillUnit', headerSx: { minWidth: "120px" }, field: 'OptHamChg' },
  { headerName: 'Pickup\nCharge', dropDown: 'PickupChgBillUnit', headerSx: { minWidth: "120px" }, field: 'PickupChg' },
  { headerName: 'DropOff\nCharge', dropDown: 'DropoffChgBillUnit', headerSx: { minWidth: "120px" }, field: 'DropoffChg' },
  { headerName: 'Valuation\nAmount', dropDown: 'ValuationBillUnit', headerSx: { minWidth: "120px" }, field: 'ValuationChg' },
  { headerName: 'Conv.\nFees', dropDown: 'ConvFeeBillUnit', headerSx: { minWidth: "120px" }, field: 'ConvFee' },
  { headerName: 'Del. Hamali\nCharges', dropDown: 'DelHamChgBillUnit', headerSx: { minWidth: "120px" }, field: 'DelHamChg' },
  { headerName: 'Delivery Opr.\nHam. Chrgs.', dropDown: 'DelOptHamBillUnit', headerSx: { minWidth: "120px" }, field: 'DelOptHamChg' },
  { headerName: 'Del. Cartage\nOn Delivery', dropDown: 'DelCartageBillUnit', headerSx: { minWidth: "120px" }, field: 'DelCartageChg' },
  { headerName: 'Demurrage\nCharges', dropDown: 'DemurrageBillUnit', headerSx: { minWidth: "120px" }, field: 'DemurrageChg' },
]

export const rateCrossingHead = [
  { headerName: 'S/N', field: 'sN', headerSx: { textAlign: 'left' } },
  { headerName: 'File Name', field: 'fileName', headerSx: {} },
  { headerName: 'Status', field: 'status', headerSx: {} },
  { headerName: 'Requested Date', field: 'requestedDate', headerSx: {} },
  { headerName: 'Requested By', field: 'requestedBy', headerSx: {} },
  { headerName: 'Cancelled Date & Time', field: 'cancelledDateTime', headerSx: {} },
  { headerName: 'Cancelled By User', field: 'cancelledByUser', headerSx: {} },
  { headerName: 'Cancelled Remark', field: 'cancelledRemark', headerSx: {} },
  { headerName: 'Action', field: 'action', headerSx: {} },
]
export const branchWiseRateHead = [
  { headerName: 'Destination City Name', field: 'destinationCityName', headerSx: { textAlign: 'left' }, showFilter: true },
  { headerName: 'By Bus', field: 'byBus', headerSx: { textAlign: 'right' }, showFilter: true },
  { headerName: 'Normal Cargo', field: 'normalCargo', headerSx: { textAlign: 'right' }, showFilter: true },
  { headerName: 'Express Cargo', field: 'expressCargo', headerSx: { textAlign: 'right' }, showFilter: true },
  { headerName: 'Partner Rate', field: 'partnerRate', headerSx: { textAlign: 'right' }, showFilter: true },
  { headerName: 'Billing Unit', field: 'billingUnit', headerSx: { textAlign: 'left' }, showFilter: true },
]
export const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
  const doc = data.doc
  // Footer
  var pageSize = doc.internal.pageSize
  var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
  var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

  var str = 'Page : ' + doc.internal.getNumberOfPages()
  if (typeof doc.putTotalPages === 'function') {
    str = str + ' of ' + totalPagesExp
  }
  doc.setFontSize(16)
  doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
  doc.setFont('Roboto', 'bold')
  doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
  doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
}

export const detailColumnsStyles = {
  0: { halign: 'right', cellWidth: 35, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  1: { halign: 'left', cellWidth: 80, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  2: { halign: 'left', cellWidth: 60, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  3: { halign: 'left', cellWidth: 125, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  4: { halign: 'left', cellWidth: 130, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  5: { halign: 'left', cellWidth: 150, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  6: { halign: 'left', cellWidth: 68, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  7: { halign: 'right', cellWidth: 66, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  8: { halign: 'right', cellWidth: 66, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  9: { halign: 'right', cellWidth: 66, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  10: { halign: 'right', cellWidth: 66, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  11: { halign: 'right', cellWidth: 67, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  12: { halign: 'right', cellWidth: 67, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  13: { halign: 'right', cellWidth: 67, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  14: { halign: 'right', cellWidth: 68, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  15: { halign: 'right', cellWidth: 68, minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
}


export const standarRateChrgOpt = [
  { id: 1, name: 'Per KG' },
  { id: 2, name: 'Per Unit' },
  { id: 4, name: 'Per KG-KM' }
]
export const standarRateChrgOnlyKGOpt = [
  { id: 1, name: 'Per KG' },
  { id: 2, name: 'Per Unit' },
]
export const standarRateOthChrgOpt = [
  { id: 1, name: 'Per KG' },
  { id: 2, name: 'Per Unit' },
  { id: 3, name: 'Per LR' }
]


export const standardMatrixObj = {
  ServiceTypeID: 0,
  ServiceType: '',
  FreightBillUnit: 0,
  Freight: 0,
  CollCartageBillUnit: 0,
  CollCartage: 0,
  CartageDelBillUnit: 0,
  CartageDel: 0,
  DocChgBillUnit: 0,
  DocChg: 0,
  HamaliChgBillUnit: 0,
  HamaliChg: 0,
  OptHamChgBillUnit: 0,
  OptHamChg: 0,
  PickupChgBillUnit: 0,
  PickupChg: 0,
  DropoffChgBillUnit: 0,
  DropoffChg: 0,
  ValuationBillUnit: 0,
  ValuationChg: 0,
  ConvFeeBillUnit: 0,
  ConvFee: 0,
  DelHamChgBillUnit: 0,
  DelHamChg: 0,
  DelOptHamBillUnit: 0,
  DelOptHamChg: 0,
  DelCartageBillUnit: 0,
  DelCartageChg: 0,
  DemurrageBillUnit: 0,
  DemurrageChg: 0
}

export const viewRateMatrixHeader = [
  { headerName: 'Source City ', field: 'SourceCity', headerSx: { textAlign: 'left' }, showfilter: true },
  { headerName: 'Destination City', field: 'DestiationCity', headerSx: {textAlign: 'left'}, showfilter: true },
  { headerName: 'Consignment ID', field: 'ConsignmentID', headerSx: {textAlign: 'right'}, showfilter: true },
  { headerName: 'Consignment Type', field: 'ConsignmentType', headerSx: {textAlign: 'left'}, showfilter: true },
  { headerName: 'Rate Type', field: 'RateType', headerSx: { textAlign: 'left' }, showfilter: true },
  { headerName: 'From KG', field: 'FromKg', headerSx: { textAlign: 'right' }, showfilter: true },
  { headerName: 'To KG', field: 'ToKg', headerSx: { textAlign: 'right' }, showfilter: true },
  { headerName: 'Freight (Per KG/Unit)', field: 'Freight', headerSx: { textAlign: 'right' }, showfilter: true },
  { headerName: 'Others (Per KG/Unit)', field: 'OtherCharges', headerSx: { textAlign: 'right', width:'300px' }, showfilter: true },
]